/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Group_WeekInputs */

const en_notifications_group_week = /** @type {(inputs: Notifications_Group_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier this week`)
};

const pl_notifications_group_week = /** @type {(inputs: Notifications_Group_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wcześniej w tym tygodniu`)
};

/**
* | output |
* | --- |
* | "Earlier this week" |
*
* @param {Notifications_Group_WeekInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_group_week = /** @type {((inputs?: Notifications_Group_WeekInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Group_WeekInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_group_week(inputs)
	return en_notifications_group_week(inputs)
});